import { useContext } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { apiPost, apiDelete } from 'api'
import AuthContext from 'context/auth-context'

const createUserMunicipality = async (token, userId, municipalityId) => {
  const url = `admin/users/${userId}/user_municipalities`
  const data = await apiPost({
    url,
    token,
    objectName: 'user_municipality',
    params: { municipality_id: municipalityId }
  })
  return data
}

const deleteUserMunicipality = async (token, userId, userMunicipalityId) => {
  const url = `admin/users/${userId}/user_municipalities/${userMunicipalityId}`
  const data = await apiDelete({ url, token })
  return data
}

export const useCreateAdminUserMunicipality = ({ userId, options } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (municipalityId) => createUserMunicipality(token, userId, municipalityId),
    {
      ...options,
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['admin-user', userId])
        if (options?.onSuccess) options.onSuccess(data, variables)
      }
    }
  )
}

export const useDeleteAdminUserMunicipality = ({ userId, options } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (userMunicipalityId) => deleteUserMunicipality(token, userId, userMunicipalityId),
    {
      ...options,
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['admin-user', userId])
        if (options?.onSuccess) options.onSuccess(data, variables)
      }
    }
  )
}
